import * as React from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import { ApPopover } from '@alixpartners/ui-components';

import { ItemChartWrapper } from './SimpleDonutChart.styles';
import { ChartMenu } from './ChartMenu';

export const SimpleDonutChart = ({
	data,
	currencySymbol,
	height = 19,
	width = 19,
	hideMenu = false,
	paddingAngle = 8,
}) => {
	const ref = React.useRef(null);
	const [isOpen, setOpen] = React.useState(false);
	const toggleOpen = () => setOpen(!isOpen);

	return (
		<React.Fragment>
			<ItemChartWrapper innerRef={ref} onClick={toggleOpen}>
				<PieChart
					data={data.map(dataItem => ({ ...dataItem, title: dataItem.name }))}
					lineWidth={60}
					paddingAngle={paddingAngle}
					style={{ height, width }}
					startAngle={-90}
				/>
			</ItemChartWrapper>
			{!hideMenu &&
				isOpen && (
					<ApPopover
						placement="top"
						referenceElement={ref.current}
						onClose={toggleOpen}
						modifiers={{
							offset: { offset: '0, 10' },
						}}
						containerProps={{ style: { zIndex: 998 } }}
						hideArrow
					>
						<ChartMenu data={data} currencySymbol={currencySymbol} />
					</ApPopover>
				)}
		</React.Fragment>
	);
};
